
function pageInit () {

}

var __blk_modifypwd = new Vue({
  data () {
    let self = this
    let checkPwd = function (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入'))
        return
      }
      if (self.form.confirmpwd === self.form.pwd) {
        callback()
      } else {
        callback(new Error('密码输入不一致'))
      }
    }
    return {
      id: '',
      dialogVisible: false,
      form: {
        pwd: '',
        confirmpwd: ''
      },
      rules: {
        pwd: [
          {required: true, min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'}
        ],
        confirmpwd: [
          {required: true, min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
          {trigger: 'blur', validator: checkPwd}
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            pwd: self.form.pwd
          }
          post({
            type: 'post',
            url: '/api/userpwd',
            data: data
          }, function (resp) {
            if (resp.status === 'success') {
              self.$message('保存成功')
              self.dialogVisible = false
            } else {
              self.$message(resp.message)
            }
          }, function (resp) {})
        } else {
          return false
        }
      });
    }
  },
  mounted () {

  }
})
